/**
 * TR cep: arayüzde maske veya 10 rakam; backend `PhoneNumber::TR_MOBILE_DIGITS_REGEX` ile uyumlu (5 + 9 rakam).
 * Maske kolu: ülke kodundan sonra alan kodu 5xx olmalı (sabit telefon 2xx vb. reddedilir).
 */

export const TR_MOBILE_INPUT_REGEX = /^(\+90 \(5\d{2}\) \d{3}-\d{4}|5\d{9})$/;

/** @param {unknown} value */
export function isValidTurkishMobileInput(value) {
    if (value == null || typeof value !== 'string') {
        return false;
    }
    return TR_MOBILE_INPUT_REGEX.test(value.trim());
}

/**
 * DB'den gelen değeri maskeye çevirir (10 haneli 5… beklenir).
 */
export function formatTurkishMobileDisplay(value) {
    if (value == null || value === '') {
        return '';
    }
    const digits = String(value).replace(/\D/g, '');
    let m = digits;
    if (m.startsWith('90') && m.length === 12) {
        m = m.slice(2);
    }
    if (m.startsWith('0') && m.length === 11) {
        m = m.slice(1);
    }
    if (m.length === 10 && m.startsWith('5')) {
        return `+90 (${m.slice(0, 3)}) ${m.slice(3, 6)}-${m.slice(6)}`;
    }
    return String(value);
}
